export const ProjectView = (projectId, t) => {
  return [
    {
      text: t('page.project_details_tab'),
      path: `/projects/view/details/${projectId}`,
      identity: `/details`,
      permission: 'projects.index'
    },
    {
      text: t('page.project_database_tab'),
      path: `/projects/view/${projectId}/database`,
      identity: '/database',
      permission: 'projects.index'
    },
    {
      text: t('page.project_team_member_tab'),
      path: `/projects/view/${projectId}/team`,
      identity: '/team',
      permission: 'projects.team.index'
    },
    {
      text: t('page.project_task_status_type_tab'),
      path: `/projects/view/${projectId}/task-status-type`,
      identity: '/task-status-type',
      permission: 'projects.taskStatusType.index'
    },
    {
      text: t('page.project_sprint_tab'),
      path: `/projects/view/${projectId}/sprint`,
      identity: '/sprint',
      permission: 'projects.sprint.index'
    },
    {
      text: t('page.project_task_tab'),
      path: `/projects/view/${projectId}/task`,
      identity: '/task',
      permission: 'projects.task.index'
    },
    {
      text: t('page.project_activity_tab'),
      path: `/projects/view/${projectId}/activities`,
      identity: '/activities',
      permission: 'projects.activities.index'
    }
  ];
};
